import { render, staticRenderFns } from "./PlaceOrderModal.vue?vue&type=template&id=6d92afe3&"
import script from "./PlaceOrderModal.vue?vue&type=script&lang=js&"
export * from "./PlaceOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports